





































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Fragment } from 'vue-fragment';

import { Poi, PoiState } from '@/models/poi';
import PoiSlideImage from '@/components/poi-slide-image.vue';
import PoiSlideAudio from '@/components/poi-slide-audio.vue';
import PoiSlideVideo from '@/components/poi-slide-video.vue';
import PoiSlidePanorama from '@/components/poi-slide-panorama.vue';
import PoiSlideArExperience from '@/components/poi-slide-ar-experience.vue';

@Component({
    components: {
        Fragment,
        PoiSlideImage,
        PoiSlideAudio,
        PoiSlideVideo,
        PoiSlidePanorama,
        PoiSlideArExperience,
    },
})
export default class PoiGalleryItemsLocked extends Vue {

    @Prop(Object) public poi: Poi;

    get locked() {
        return this.poi.state !== PoiState.UNLOCKED;
    }

    public single_item(content: any[]) {
        if (!content || content.length === 0) return [];
        return content.slice(0, 1);
    }
}
